import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { QuantityUnitDto } from '../../services/INTEGRA_Shop_Client';

/**
 * Pipe regarding the displaying of quantity units in their plural form.
 * requires an import in the decorator.
 * usage only inside the html template. NO TS CODE.
 * for ts code useage @see QuantityUnitToPluralStringService
 */
@Pipe({
  name: 'quantityUnitToPluralString',
  standalone: true
})
export class QuantityUnitToPluralStringPipe implements PipeTransform {

  public transform(quantityUnit?: QuantityUnitDto): string {
    return QuantityUnitToPluralStringService.transform(quantityUnit);
  }

}

/**
 * Pipe regarding the displaying of quantity units in their plural form.
 * no import required.
 * no instance required.
 * usage only inside the ts code. NO HTML TEMPLATE.
 * for html template usage @see QuantityUnitToPluralStringPipe
 */
@Injectable({
  providedIn: 'root'
})
export class QuantityUnitToPluralStringService {

  public static transform(quantityUnit?: QuantityUnitDto): string {
    if (quantityUnit == undefined) {
      return '';
    }

    let quantityUnitString = `${quantityUnit.quantityUnitCaption}`;
    let pluralSuffix = 's';

    quantityUnitString = `${quantityUnitString}${pluralSuffix}`;

    return quantityUnitString;
  }

}
